"use strict";
import e from "./index.es99.js";
import F from "./index.es110.js";
function p(n) {
  return e.isPlainObject(n) || e.isArray(n);
}
function B(n) {
  return e.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function w(n, o, r) {
  return n ? n.concat(o).map(function(u, a) {
    return u = B(u), !r && a ? "[" + u + "]" : u;
  }).join(r ? "." : "") : o;
}
function S(n) {
  return e.isArray(n) && !n.some(p);
}
const T = e.toFlatObject(e, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function U(n, o, r) {
  if (!e.isObject(n))
    throw new TypeError("target must be an object");
  o = o || new FormData(), r = e.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(t, i) {
    return !e.isUndefined(i[t]);
  });
  const u = r.metaTokens, a = r.visitor || h, b = r.dots, m = r.indexes, y = (r.Blob || typeof Blob < "u" && Blob) && e.isSpecCompliantForm(o);
  if (!e.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(t) {
    if (t === null) return "";
    if (e.isDate(t))
      return t.toISOString();
    if (e.isBoolean(t))
      return t.toString();
    if (!y && e.isBlob(t))
      throw new F("Blob is not supported. Use a Buffer instead.");
    return e.isArrayBuffer(t) || e.isTypedArray(t) ? y && typeof Blob == "function" ? new Blob([t]) : Buffer.from(t) : t;
  }
  function h(t, i, s) {
    let f = t;
    if (t && !s && typeof t == "object") {
      if (e.endsWith(i, "{}"))
        i = u ? i : i.slice(0, -2), t = JSON.stringify(t);
      else if (e.isArray(t) && S(t) || (e.isFileList(t) || e.endsWith(i, "[]")) && (f = e.toArray(t)))
        return i = B(i), f.forEach(function(d, A) {
          !(e.isUndefined(d) || d === null) && o.append(
            // eslint-disable-next-line no-nested-ternary
            m === !0 ? w([i], A, b) : m === null ? i : i + "[]",
            l(d)
          );
        }), !1;
    }
    return p(t) ? !0 : (o.append(w(s, i, b), l(t)), !1);
  }
  const c = [], O = Object.assign(T, {
    defaultVisitor: h,
    convertValue: l,
    isVisitable: p
  });
  function j(t, i) {
    if (!e.isUndefined(t)) {
      if (c.indexOf(t) !== -1)
        throw Error("Circular reference detected in " + i.join("."));
      c.push(t), e.forEach(t, function(s, f) {
        (!(e.isUndefined(s) || s === null) && a.call(
          o,
          s,
          e.isString(f) ? f.trim() : f,
          i,
          O
        )) === !0 && j(s, i ? i.concat(f) : [f]);
      }), c.pop();
    }
  }
  if (!e.isObject(n))
    throw new TypeError("data must be an object");
  return j(n), o;
}
export {
  U as default
};
//# sourceMappingURL=index.es109.js.map
